import { CheckboxField } from '@e3dc-react/shell/Elements/InputFields'
import { TableComplete } from '@e3dc-react/shell/Elements/Table'
import { Header } from '@e3dc-react/shell/Elements/Table/Table'
import { Typography } from '@mui/material'
import React from 'react'
import { DcbhistoryModule } from './BatteryExportUtils'

interface BatteryDcbhistoryListProps {
  data: DcbhistoryModule[]
  dcbHistoryIdxsToInclude: boolean[]
  setDcbHistoryIdxsToInclude: (dcbHistoryIdxsToInclude: boolean[]) => void
}

const BatteryDcbistoryList: React.VFC<BatteryDcbhistoryListProps> = ({ data, dcbHistoryIdxsToInclude, setDcbHistoryIdxsToInclude }) => {
  const onIncludeHistory = (index: number, isChecked: boolean): void => {
    const copy = [...dcbHistoryIdxsToInclude]
    copy[index] = isChecked
    setDcbHistoryIdxsToInclude(copy)
  }

  const tableColumns: Header<DcbhistoryModule>[] = [
    {
      value: 'checkbox',
      label: '',
      valueRender: (value, index) => {
        return <CheckboxField value={dcbHistoryIdxsToInclude[index]} onChange={isChecked => onIncludeHistory(index, isChecked)} />
      },
    },
    {
      value: 'serialno',
      label: 'serialno',
      valueRender: (value, index) => {
        return <Typography>{value}</Typography>
      },
    },
    {
      value: 'tcSerialCode',
      label: 'tcSerialCode',
      valueRender: (value, index) => {
        return <Typography>{value}</Typography>
      },
    },
    {
      value: 'from',
      label: 'from',
      valueRender: (value, index) => {
        return <Typography>{value}</Typography>
      },
    },
    {
      value: 'to',
      label: 'to',
      valueRender: (value, index) => {
        return <Typography>{value}</Typography>
      },
    },
    {
      value: 'bat_index',
      label: 'bat_index',
      valueRender: (value, index) => {
        return <Typography>{value}</Typography>
      },
    },
    {
      value: 'DCBAddr',
      label: 'DCBAddr',
      valueRender: (value, index) => {
        return <Typography>{value}</Typography>
      },
    },
  ]

  return (
    <div>
      <TableComplete header={tableColumns} data={data} disablePagination headerElevation={0} bodyElevation={0} />
    </div>
  )
}

export default BatteryDcbistoryList
